// src/Home.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./optolog_logo.png";

function Home() {
  const navigate = useNavigate();
  const [institution, setInstitution] = useState("");

  const handleContinue = () => {
    if (!institution) return alert("Please select your institution.");
    navigate("/login");
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <img src={logo} alt="OptoLog Logo" style={styles.logo} />
        <p style={styles.welcomeText}>Welcome to OptoLog</p>
        <p style={styles.instructionText}>Please select your institution to continue:</p>

        <select
          value={institution}
          onChange={(e) => setInstitution(e.target.value)}
          style={styles.select}
        >
          <option value="">Select your institution</option>
<option value="RMU">Rocky Mountain University of Health Professions - College of Optometric Medicine</option>
<option value="UAB">University of Alabama at Birmingham School of Optometry</option>
<option value="AZCOPT">Arizona College of Optometry – Midwestern University</option>
<option value="MBKU">Southern California College of Optometry – Marshall B. Ketchum University</option>
<option value="UCB">University of California, Berkeley School of Optometry</option>
<option value="WESTU">Western University of Health Sciences College of Optometry</option>
<option value="NSUFL">Nova Southeastern University College of Optometry</option>
<option value="ICO">Illinois College of Optometry</option>
<option value="CCO">Chicago College of Optometry – Midwestern University</option>
<option value="IU">Indiana University School of Optometry</option>
<option value="KYCO">University of Pikeville – Kentucky College of Optometry</option>
<option value="MCPHS">MCPHS University School of Optometry</option>
<option value="NECO">New England College of Optometry</option>
<option value="MCO">Michigan College of Optometry – Ferris State University</option>
<option value="UDM">University of Detroit Mercy School of Optometry</option>
<option value="UMSL">University of Missouri–St. Louis College of Optometry</option>
<option value="SUNY">SUNY College of Optometry</option>
<option value="OSU">The Ohio State University College of Optometry</option>
<option value="NSUOK">Northeastern State University Oklahoma College of Optometry</option>
<option value="PACIFIC">Pacific University College of Optometry</option>
<option value="SALUS">Salus University Pennsylvania College of Optometry</option>
<option value="IAUPR">Inter American University of Puerto Rico School of Optometry</option>
<option value="SCO">Southern College of Optometry</option>
<option value="UHCO">University of Houston College of Optometry</option>
<option value="UIWRSO">University of the Incarnate Word – Rosenberg School of Optometry</option>

        </select>

        <br />

        <button onClick={handleContinue} style={styles.button}>Continue</button>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#20466b",
    fontFamily: "'Poppins', sans-serif",
    padding: "20px",
  },
  container: {
    textAlign: "center",
    color: "#00ffca",
    maxWidth: "500px",
    width: "100%",
    padding: "20px",
  },
  logo: {
    width: "80%",
    maxWidth: "400px",
    marginBottom: "20px",
  },
  welcomeText: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  instructionText: {
    fontSize: "18px",
    marginBottom: "10px",
  },
  select: {
    fontSize: "16px",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "20px",
    width: "100%",
    maxWidth: "300px",
  },
  button: {
    fontSize: "16px",
    padding: "12px 24px",
    backgroundColor: "#00ffca",
    color: "#20466b",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  select: {
  fontSize: "16px",
  padding: "12px 16px",
  borderRadius: "8px",
  marginBottom: "20px",
  width: "100%",
  maxWidth: "360px",
  backgroundColor: "#f9f9f9",
  border: "2px solid #00ffca",
  color: "#20466b",
  fontFamily: "'Poppins', sans-serif",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  backgroundImage:
    "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%2300ffca' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 12px center",
  backgroundSize: "10px 6px",
},


};

export default Home;
